module.exports = __webpack_public_path__ + "static/undraw_prototyping_process_rswj-325058c7c5f1c3977af1d5ba92bdec42.svg";